export default "__VITE_ASSET__lUW2RM7E__"